import { h, Component, Fragment } from 'preact';
import { route } from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import Config from "../config";
import Page from "../../../services/page-data-feed";
import Ticket, { RichiamaPrenotataApi } from "../../../services/ticket";
import User from "../../../services/user"
import LFeed from "../../../services/live-feed";
import TicketUtils from "../utils/ticket-logic.jsx";
import formatOdd from "../../../services/odds-format";

import * as I from "../utils/icons.jsx";

import * as P from "../mobile-templates/ticket.jsx";
import MoneyFormatter from "../utils/money-formatter";
import TicketLogic from '../utils/ticket-logic.jsx';

import { 
TicketHeader as AwrabetTicketHeader,
TicketBody as AwrabetTicketBody,
TicketSelections as AwrabetTicketSelections,
SystemSelectionInterface as AwrabetSystemSelectionInterface,
StateInput as AwrabetStateInput,
RegularSelectionInterface as AwrabetRegularSelectionInterface,
TicketWarnings as AwrabetTicketWarnings,
bookedBetLink,
TicketStatusWaitLive,

 } from '../../awrabet/mobile-pages/ticket-ltn';

export class TicketHeader extends AwrabetTicketHeader {
	render({ closePopup }) {
		return <Fragment>
			<P.BetslipButton active={true}>
				<Trans>Betslip</Trans> <P.BetslipIndicator>{Ticket.countOdds()}</P.BetslipIndicator>
			</P.BetslipButton>
			{Page.user.isLogged() && <P.BetslipButton onClick={e => this.openMyBets(closePopup)}>My Bets</P.BetslipButton>}
			<P.BetslipButton>Settings</P.BetslipButton>
			<P.BetslipButton>Decimal</P.BetslipButton>
			{closePopup && <P.BestslipCloseButton onClick={closePopup}>
				<I.CloseIconBold class="inline-block h-7 fill-current" />
			</P.BestslipCloseButton>}
		</Fragment>
	}
}

export class TicketBody extends AwrabetTicketBody {
	render() {
		if (!Ticket.hasOdds())
			return <div class="empty-ticket text-center text-sm px-4 py-5">
				<Trans>No bet has been selected. To select a bet, please click on the respective odds</Trans>
			</div>;

		if (Ticket.isWaitingLive() || Ticket.isWaitingPrematch() || Ticket.needsFlatteningConfirm())
			return null;

		if (!!Ticket.status)
			return null;

		return <Fragment>
			<TicketSelections />
			<TicketRowPlayAs />
			<SelectionInterface />
			<TicketWarnings />
			<P.TicketButtonsContainer>
				<P.SaveButton onClick={() => Ticket.reserve()} disabled={!Ticket.canReserve()}>
					<span class="block w-4"><I.SaveIcon class="h-4" /></span>
					<span class="block"><Trans>Save</Trans></span>
					<span class="block w-4"></span>
				</P.SaveButton>
				<div class="flex w-full justify-between items-center h-10 overflow-hidden rounded">
					<P.CancelButton onClick={() => Ticket.reset()}>
						<span class="block"><I.ClearIcon class="h-4" /></span>
						<span class="block"><Trans>Clear</Trans></span>
						<span class="block"></span>
					</P.CancelButton>
					<P.PlaceButton onClick={() => {
						if (!User.isLogged()) {
							location.hash = "#login";
							return;
						}
						TicketUtils.play();
					}} disabled={User.isLogged() ? !Ticket.canPlay() : false}>
						<span class="block"><Trans>Bet</Trans></span>
					</P.PlaceButton>
				</div>
			</P.TicketButtonsContainer>
		</Fragment>
	}
}

export function TicketRowPlayAs() {
	if (!User.isLogged() || !User.isAffiliate())
		return null;

	const longestName = (User.data.users || []).map(a => a.username.length).reduce((a, b) => Math.max(a, b), 0) + 3;
	const longestSize = Math.min(longestName, 35);
	// Monospace white char: " " (fai copia/incolla)
	const currentPlayAs = TicketLogic.getCurrentPlayAs();
	const currentPlayer = !currentPlayAs ? null : User.data.users.find(user => currentPlayAs == user.idaccounts)
	return <div class="betslip_playas flex flex-row items-center justify-center flex-wrap bg-slate-100 text-slate-950 px-2 py-1 border-b border-b-slate-300">
		<div class="w-1/2 grow text-left text-sm font-medium">
			<Trans>Gioca come:</Trans>
		</div>
		<span class="w-3/5 hidden wrap-break-word" />
		<div class="w-1/2 grow">
			<select class="main-content-form-element text-sm block w-full rounded p-2 border border-slate-300 bg-white text-slate-950" onChange={e => TicketLogic.playAs(e.currentTarget.value)}>
				<option value="0" selected={!TicketLogic.getCurrentPlayAs()}><Trans>Cassa</Trans></option>
				{!!User.data.users && User.data.users
					.slice(0, 100)
					.sort((a, b) => a.username.localeCompare(b.username, {sensitivity: 'accent'}))
					.map(user => <option class="font-mono" value={user.idaccounts} selected={TicketLogic.getCurrentPlayAs() === parseInt(user.idaccounts)}>
						{user.username.padEnd(longestSize, " ")}{true ? '' : `[${user.currency} ${parseFloat(user.saldo).toFixed(2)}]`}
					</option>)}
			</select>
		</div>
		{!!TicketLogic.getCurrentPlayAs() && <div class="w-full grid grid-cols-2 shrink-0 pt-2 text-sm">
			<div class="text-left font-medium">
				<Trans>Username: </Trans>
			</div>
			<div class="text-right text-slate-700">
				{currentPlayer.username}
			</div>
			{false && <div class="text-left">
				<Trans>Balance: </Trans>
			</div>}
			{false && <div class="font-mono text-right">
				<span class={"text-sm "+(currentPlayer.saldo < TicketLogic.getBetAmount() ? 'text-red-600' : '')}>
					{parseFloat(currentPlayer.saldo).toFixed(2)}
				</span>
				&nbsp;
				<span class="text-xs">
					{currentPlayer.currency}
				</span>
			</div>}
		</div>}
	</div>;
}

export class TicketSelections extends AwrabetTicketSelections {
	render() {
		const eventsList = TicketUtils.getOdds();
		return <P.BestlipOddsSection>
			{eventsList.map(({ event, outcomes, sport, category, tournament, closed }) => <P.TicketRow closed={closed}>
				<P.TicketEventHeader>
					<P.TicketEventName>
						<div class="flex flex-col">
							<div class="truncate">
								<a class="hover:underline" onClick={e => {
									window.location.hash = '';
									console.log(event.date);
									const isPrematch = event.date < Date.now();
									const url = isPrematch
										? "/prematch" + event.parent.replace('/tournament', '') + event.id.replace('/event', '')
										: "/live" + event.id
									route(url);
								}}>{event.home}{event.away ? " - " + event.away : ''}</a>
							</div>
							<div class="italic font-normal text-xxs text-slate-300 truncate">{sport.name} - {category.name} - {tournament.name}</div>
						</div>
					</P.TicketEventName>
					{TicketUtils.isSystem()
						? (outcomes.length === 1
							? <P.TicketSystemOddsLockBtn onClick={() => TicketUtils.toggleSystemFixedOdds(outcomes[0].id)}>
								{!!outcomes[0].block
									? <I.CircleCheck class="inline-block h-3 fill-current" />
									: <I.Circle class="inline-block h-3 fill-current" />}
							</P.TicketSystemOddsLockBtn>
							: null)
						: <P.TicketEventRemoveBtn onClick={() => TicketUtils.removeOdds(outcomes[0].id)}>
							<I.CloseIcon class="inline-block h-3 fill-current" />
						</P.TicketEventRemoveBtn>}
				</P.TicketEventHeader>
				{outcomes.map(outcome => <P.TicketEventOdd closed={!closed && outcome.closed}>
					{!outcome.odds.selection
						? <P.MarketContainer>
							<span>{outcome.market.name}:</span>
							<P.OutcomeName>{outcome.odds.name}</P.OutcomeName>
						</P.MarketContainer>
						: <P.MarketContainer>
							<span>{outcome.market.name}:</span>
							<div class="block">
								<BetbuilderRows odds={outcome.odds} />
							</div>
						</P.MarketContainer>}
					<P.OutcomeValue value={outcome.odds.value} />
					{!TicketUtils.isSystem() ? null :
						<P.TicketEventRemoveBtn onClick={() => TicketUtils.removeOdds(outcome.id)}>
							<I.CloseIcon class="inline-block h-3 fill-current" />
						</P.TicketEventRemoveBtn>}
					{!closed && outcome.closed && <P.OddsError><Trans>This bet is not available</Trans></P.OddsError>}
				</P.TicketEventOdd>)}
				{closed && <P.OddsError><Trans>No bets available for this match</Trans></P.OddsError>}
			</P.TicketRow>)}
		</P.BestlipOddsSection>
	}
}

const BetslipAmountHelperRender = () => <div class="flex items-start justify-center gap-1 text-center h-10">
	{(Config.betting['ticket-stake-preset'] || []).map(
		amount => <a
			class="flex w-full shrink grow bg-amber-400 py-2 text-center items-center justify-center text-sm uppercase text-black rounded-full border border-amber-500 cursor-pointer"
			onClick={e => {
				e.preventDefault();
				// Ticket.setImport(parseFloat(Ticket.data.bet || 0) + parseFloat(Ticket.data.betTax || 0) + parseFloat(amount));
				Ticket.setImport(parseFloat(amount));
				Page.rerender();
			}}
		>
			{amount}
		</a>
	)}
</div>;

const BetbuilderPieceIcon = ({ first, last, ...props }) => {
	return <svg viewBox="0 0.0001 32.110703 86.009547" xmlns="http://www.w3.org/2000/svg" style={props['style']} class={"fill-current " + (props['class'] || '')}>
		{last ? null : <path style="fill:currentColor;stroke-width:1.829;stroke-linecap:round;stroke-linejoin:round" d="M37.939772 124.32781v30.625h9.200473v-30.61828a13.218359 13.218359 0 0 1-4.600237.82682 13.218359 13.218359 0 0 1-4.600236-.83354z" transform="translate(-26.484658 -68.93326)" />}
		{first ? null : <path style="fill:currentColor;stroke-width:1.829;stroke-linecap:round;stroke-linejoin:round" d="M37.939772 68.93326v30.625002a13.218359 13.218359 0 0 1 4.600236-.833541 13.218359 13.218359 0 0 1 4.600237.826823V68.93326Z" transform="translate(-26.484658 -68.93326)" />}
		<path style="fill:currentColor;stroke-width:2.22156;stroke-linecap:round;stroke-linejoin:round" d="M42.540008 95.887687a16.055462 16.055462 0 0 0-16.05535 16.055353 16.055462 16.055462 0 0 0 16.05535 16.05535 16.055462 16.055462 0 0 0 16.055351-16.05535 16.055462 16.055462 0 0 0-16.055351-16.055353zm0 2.837034a13.218359 13.218359 0 0 1 13.218316 13.218319 13.218359 13.218359 0 0 1-13.218316 13.21831 13.218359 13.218359 0 0 1-13.218313-13.21831 13.218359 13.218359 0 0 1 13.218313-13.218319Z" transform="translate(-26.484658 -68.93326)" />
		<path style="fill:currentColor;stroke-width:1.282;stroke-linecap:round;stroke-linejoin:round" d="M51.805208 111.94297a9.2651291 9.2651291 0 0 1-9.265129 9.26513 9.2651291 9.2651291 0 0 1-9.265129-9.26513 9.2651291 9.2651291 0 0 1 9.265129-9.26513 9.2651291 9.2651291 0 0 1 9.265129 9.26513z" transform="translate(-26.484658 -68.93326)" />
	</svg>
}

const BetBuilderItemFormat = ({ market, outcome, first, last }) =>
	<div class="flex">
		<div class="w-3.5 h-full">
			<BetbuilderPieceIcon first={first} last={last} class="h-full" />
		</div>
		<div class="flex flex-col h-full pl-2 py-0.5">
			<div class="font-bold text-xs">{market}</div>
			<div class="font-light fext-sm">{outcome}</div>
		</div>
	</div>;

function BetbuilderRows({ odds }) {
	const entries = odds.name.split(' AND ');
	return entries.map(
		(market, i) => {
			const names = market.split(' - ');
			return <BetBuilderItemFormat market={names[0]} outcome={names[1]} first={i === 0} last={entries.length - 1 === i} />;
		}
	)
}

export function SelectionInterface() {
	return <Fragment>
		<P.TicketSelectionsRowLarge>
			<P.SelectionTypeButton active={TicketUtils.isMultiple()} onClick={() => TicketUtils.forceMultiple()}><Trans>MULTIPLE</Trans></P.SelectionTypeButton>
			<P.SelectionTypeButton active={TicketUtils.isSystem()} onClick={() => TicketUtils.forceSystem()}><Trans>SYSTEM</Trans></P.SelectionTypeButton>
		</P.TicketSelectionsRowLarge>
		{/*Qui caricare l'interfaccia di sistemi*/}
		{TicketUtils.isSystem()
			? <SystemSelectionInterface />
			: <RegularSelectionInterface />}
	</Fragment>
}

export class SystemSelectionInterface extends AwrabetSystemSelectionInterface {
	render() {
		return <Fragment>
			{!!TicketUtils.getSystem() && TicketUtils.getSystem().length
				? TicketUtils.getSystem().map(
					system => <Fragment>
						<P.TicketSystemStakeRow>
							<P.PaddedCellHalfWidth>
								{P.TicketSystemStakeName(parseInt(system.split) + TicketUtils.countFixedOdds())}
							</P.PaddedCellHalfWidth>
							<P.PaddedCellThirthWidth>
								{system.num}
							</P.PaddedCellThirthWidth>
							<StateInput
								disabled={TicketUtils.isConfirmNeeded()}
								value={system.bet}
								onInput={e => TicketUtils.setBetAmount(e.target.value, system.split)}
								onIncrement={() => { TicketUtils.setBetAmount((parseFloat(system.bet) + 1.00) + '', system.split) }}
								onDecrement={() => { TicketUtils.setBetAmount((Math.max(0, parseFloat(system.bet) - 1.00) + ''), system.split) }}
							/>
						</P.TicketSystemStakeRow>
						{!!system.preview ?
							<P.TicketSystemPreviewRow>
								<P.PaddedCellHalfWidth>
									<P.TicketSystemPreviewMinWin minwin={system.preview.minwin} />
								</P.PaddedCellHalfWidth>
								<P.PaddedCellHalfWidth>
									<P.TicketSystemPreviewMaxWin maxwin={system.preview.maxwin} />
								</P.PaddedCellHalfWidth>
							</P.TicketSystemPreviewRow>
							: null}
					</Fragment>
				) : null}
			<P.TicketTotalOddRow>
				<P.PaddedCell><Trans>Odds</Trans></P.PaddedCell>
				<P.PaddedCell>{formatOdd(TicketUtils.getTotalOdds())}</P.PaddedCell>
			</P.TicketTotalOddRow>
			<P.TicketTotalStakeRow>
				{/*<P.PaddedCell><Trans>Stake</Trans></P.PaddedCell>*/}
				<StateInput
					value={TicketUtils.getBetAmount()}
					onInput={e => TicketUtils.setBetAmount(e.target.value)}
					onIncrement={() => { TicketUtils.setBetAmount((parseFloat(TicketUtils.getBetAmount()) + 1.00) + '') }}
					onDecrement={() => { TicketUtils.setBetAmount((Math.max(0, parseFloat(TicketUtils.getBetAmount()) - 1.00) + '')) }}
				/>
			</P.TicketTotalStakeRow>
			<P.TicketHelperButtonsContainer>
				<BetslipAmountHelperRender />
			</P.TicketHelperButtonsContainer>
			{Ticket.data.isBonusAdded
				? <P.TicketTotalStakeRow>
					<P.PaddedCell><Trans>Bonus</Trans></P.PaddedCell>
					<P.PaddedCell><MoneyFormatter value={TicketUtils.getBonusAmount()} /></P.PaddedCell>
				</P.TicketTotalStakeRow>
				: null}
			{TicketUtils.getWinAmount() <= 0 || TicketUtils.isEmpty() ? null : <P.RegularTicketWinPreview>
				<P.RegularTicketWinLabel><Trans>Potential winning</Trans></P.RegularTicketWinLabel>
				<P.RegularTicketWinAmountBold>{TicketUtils.getWinAmount().toFixed(2)} {Config.betting['currency']}</P.RegularTicketWinAmountBold>
			</P.RegularTicketWinPreview>}
		</Fragment>
	}
}

export class StateInput extends AwrabetStateInput {
	render({ }) {
		return <P.StakeInput
			disabled={this.props.disabled}
			value={this.state.focused ? this.state.value : this.props.value}
			onInput={e => this.setInput(e)}
			onBlur={e => this.setState({ focused: console.log("DEFOCUS") })}
			onIncrement={() => { this.setState({ focused: false }); this.props.onIncrement() }}
			onDecrement={() => { this.setState({ focused: false }); this.props.onDecrement() }}
		/>
	}
}

export class RegularSelectionInterface extends AwrabetRegularSelectionInterface {
	render() {
		return <Fragment>
			<P.TicketTotalOddRow>
				<P.PaddedCell><Trans>Odds</Trans></P.PaddedCell>
				<P.PaddedCell>{formatOdd(TicketUtils.getTotalOdds())}</P.PaddedCell>
			</P.TicketTotalOddRow>
			<P.TicketTotalStakeRow>
				{/*<P.PaddedCell><Trans>Stake</Trans></P.PaddedCell>*/}
				<StateInput
					value={TicketUtils.getBetAmount()}
					onInput={e => TicketUtils.setBetAmount(e.target.value)}
					onIncrement={() => { TicketUtils.setBetAmount((parseFloat(TicketUtils.getBetAmount()) + 1.00) + '') }}
					onDecrement={() => { TicketUtils.setBetAmount((Math.max(0, parseFloat(TicketUtils.getBetAmount()) - 1.00) + '')) }}
				/>
			</P.TicketTotalStakeRow>
			<P.TicketHelperButtonsContainer>
				<BetslipAmountHelperRender />
			</P.TicketHelperButtonsContainer>
			{Ticket.data.isBonusAdded
				? <TicketBonusMeter amount={parseFloat(TicketUtils.getBonusAmount())} />
				: null}
			{TicketUtils.isEmpty() ? null : <Fragment>
				{TicketUtils.getBetTaxAmount() <= 0 ? null : <P.RegularTicketWinPreview>
					<P.RegularTicketWinLabel><Trans>VAT</Trans></P.RegularTicketWinLabel>
					<P.RegularTicketWinAmount>{TicketUtils.getBetTaxAmount().toFixed(2)} {Config.betting['currency']}</P.RegularTicketWinAmount>
				</P.RegularTicketWinPreview>}
				{TicketUtils.getBetTaxAmount() <= 0 ? null : <P.RegularTicketWinPreview>
					<P.RegularTicketWinLabel><Trans>Stake after VAT</Trans></P.RegularTicketWinLabel>
					<P.RegularTicketWinAmount>{(TicketUtils.getBetAmount() - TicketUtils.getBetTaxAmount()).toFixed(2)} {Config.betting['currency']}</P.RegularTicketWinAmount>
				</P.RegularTicketWinPreview>}
				{TicketUtils.getWinTaxAmount() <= 0 ? null : <>
					<P.RegularTicketWinPreview>
						<P.RegularTicketWinLabel><Trans>Win Before VAT</Trans></P.RegularTicketWinLabel>
						<P.RegularTicketWinAmount>{TicketUtils.getWinBeforeTaxAmount().toFixed(2)} {Config.betting['currency']}</P.RegularTicketWinAmount>
					</P.RegularTicketWinPreview>
					<P.RegularTicketWinPreview>
						<P.RegularTicketWinLabel><Trans>Win VAT</Trans></P.RegularTicketWinLabel>
						<P.RegularTicketWinAmount>{TicketUtils.getWinTaxAmount().toFixed(2)} {Config.betting['currency']}</P.RegularTicketWinAmount>
					</P.RegularTicketWinPreview>
				</>}
				{TicketUtils.getWinAmount() <= 0 ? null : <P.RegularTicketWinPreview>
					<P.RegularTicketWinLabel><Trans>Potential winning</Trans></P.RegularTicketWinLabel>
					<P.RegularTicketWinAmountBold>{TicketUtils.getWinAmount().toFixed(2)} {Config.betting['currency']}</P.RegularTicketWinAmountBold>
				</P.RegularTicketWinPreview>}
			</Fragment>}
		</Fragment>
	}
}

export function TicketBonusMeter({ amount }) {
	if (isNaN(amount) || amount <= 0)
		return null;

	const winamount = TicketUtils.getWinAmount();
	const percentage = amount / (winamount - amount);

	return <P.TicketBonusPanel>
		<P.TicketBonusInfoRow>
			<P.TicketBonusInfoCell>Bonus</P.TicketBonusInfoCell>
			<P.TicketBonusInfoCell>{(percentage * 100).toFixed(0)}% / {amount.toFixed(2)}</P.TicketBonusInfoCell>
		</P.TicketBonusInfoRow>
		<P.Progressbar percentage={percentage} />
	</P.TicketBonusPanel>
}

export class TicketWarnings extends AwrabetTicketWarnings {
	render() {
		if (!User.isLogged())
			return <P.WarningRow>
				<P.WarningIcon /> <Trans>You need to login to be able to place a bet.</Trans>
			</P.WarningRow>;
		if (Ticket.isBonusOnly()) {
			const minBonusBet = Ticket.getMinBonusBet();
			if (minBonusBet > 0) {
				return <P.WarningRow>
					<P.WarningIcon /> <Trans>Minimum stake for bonus bets is</Trans> {minBonusBet.toFixed(2)} {Config.betting['currency']}
				</P.WarningRow>;
			}
		}
		return null;
	}
}

export function EndedTicketPopups() {
	if (Ticket.isWaitingLive()) {
		return <StatusMessage>
			<I.HourglassSlim class="h-12" />
			<StatusMessageText><Trans>Please wait</Trans>{!!Ticket.status.data.until ? <span>: <b><TicketStatusWaitLive untilTime={Ticket.status.data.until} /></b></span> : ''}</StatusMessageText>
		</StatusMessage>;
	}
	if (Ticket.isWaitingPrematch()) {
		return <StatusMessage>
			<I.HourglassSlim class="h-12" />
			<StatusMessageText><Trans>Please wait</Trans></StatusMessageText>
		</StatusMessage>;
	}
	if (Ticket.isConfirmingBonusFunds()) {
		return <StatusMessage>
			<I.TriangleExclamation class="h-12 text-amber-500" />
			<StatusMessageText><Trans>Insufficient funds</Trans></StatusMessageText>
			<StatusMessageText>
				<Trans>You don't have enough real money. Do you want to use</Trans>{' '}
				<MoneyFormatter value={Ticket.status.data.needed} currency={Config.betting['currency']} />
				{' '}<Trans>from your bonus wallet?</Trans>
				<br />
				<small><Trans>Available bonus</Trans>: <MoneyFormatter value={Ticket.status.data.bonusAmount} currency={Config.betting['currency']} /></small>
			</StatusMessageText>
			<StatusMessageButtons>
				<StatusMessageCancel onClick={() => { Ticket.reset() }}><Trans>Cancel</Trans></StatusMessageCancel>
				<StatusMessageAccept onClick={() => { Ticket.confirmBonusFunds() }}><Trans>Use Bonus</Trans></StatusMessageAccept>
			</StatusMessageButtons>
		</StatusMessage>;
	}
	if (Ticket.isNotPlaced() && Ticket.status.data.type == 'login') {
		return null; // Qui non ci arrivi, non ti deve far scommettere prima
	}
	if (Ticket.isNotPlaced() && Ticket.status.data.type != 'login') {
		return <StatusMessage>
			<I.CircleXmark class="h-12 text-red-600" />
			<StatusMessageText>{ERROR_TITLES[Ticket.status.data.type + ':' + Ticket.status.data.body] || ERROR_TITLES.default}</StatusMessageText>
			<StatusMessageText>{ERROR_MESSAGES[Ticket.status.data.type + ':' + Ticket.status.data.body] || (Ticket.status.data.type + ':' + Ticket.status.data.body)}</StatusMessageText>
			{ERROR_INFO[Ticket.status.data.type + ':' + Ticket.status.data.body] ? <StatusMessageText>
				{ERROR_INFO[Ticket.status.data.type + ':' + Ticket.status.data.body].additionalData(Ticket.status.data)}
			</StatusMessageText> : null}
			<StatusMessageButtons>
				<StatusMessageCancel onClick={() => { Ticket.reset() }}><Trans>Cancel</Trans></StatusMessageCancel>
				<StatusMessageAccept onClick={() => { Ticket.continue() }}><Trans>Continue</Trans></StatusMessageAccept>
			</StatusMessageButtons>
		</StatusMessage>;
	}
	if (Ticket.needsFlatteningConfirm()) {
		return <StatusMessage>
			<I.TriangleExclamation class="h-12 text-yellow-600" />
			<StatusMessageText><Trans>The win amount has changed, it is now</Trans>: {Ticket.flattenwin}</StatusMessageText>
			<StatusMessageButtons>
				<StatusMessageCancel onClick={() => { Ticket.reset() }}><Trans>Cancel</Trans></StatusMessageCancel>
				<StatusMessageAccept onClick={() => { Ticket.flattenAcceptFunction() }}><Trans>Confirm</Trans></StatusMessageAccept>
			</StatusMessageButtons>
		</StatusMessage>;
	}
	if (Ticket.isPendingApproval()) {
		return <StatusMessage>
			<I.HourglassSlim class="h-12 animate-spin" />
			<StatusMessageText><Trans>Your ticket is being reviewed by an operator. Please wait</Trans></StatusMessageText>
		</StatusMessage>;
	}
	if (Ticket.isPlaced()) {
		return <StatusMessage>
			<I.CircleCheck class="h-12 text-green-600" />
			<StatusMessageText>
				{Ticket.status.data.reserved
					? <h3><Trans>Your bet is successfully reserved</Trans></h3>
					: <h3><Trans>Your bet is successfully accepted</Trans></h3>}
				{Ticket.status.data.reserved
					? <div class="flex flex-col gap-2 items-center justify-center mt-2">
						<div class="flex gap-2 items-center justify-center">
							<h3 class="text-3xl font-bold">{Ticket.status.data.pendingId}</h3>
							<div class="bg-amber-500 text-slate-900 px-3 py-1 shadow-lg cursor-pointer rounded-md font-bold" onClick={e => navigator.clipboard.writeText(bookedBetLink(Ticket.status.data.pendingId))}>
								<Trans>Copy Link</Trans>
							</div>
						</div>
						<div class="flex flex-col items-center justify-center w-full mt-2">
							<div class="text-sm font-bold uppercase tracking-wider"><Trans>Share</Trans> <I.ShareIcon class="h-3 inline-block" /></div>
							<div class="w-1/2 h-px bg-slate-300 my-2"></div>
							<div class="flex gap-4 items-center justify-center">
								<a class="w-10 h-10 text-blue-700 flex items-center justify-center" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.origin + '/recall/' + Ticket.status.data.pendingId)}`} target="_blank">
									<I.FacebookIcon class="h-8" />
								</a>
								<div class="w-10 h-10 text-black cursor-pointer flex items-center justify-center" onClick={e => shareReservedBet(Ticket.status.data.pendingId)}>
									<I.TiktokIcon class="h-8" />
								</div>
								<div class="w-10 h-10 text-pink-600 cursor-pointer flex items-center justify-center" onClick={e => shareReservedBet(Ticket.status.data.pendingId)}>
									<I.InstagramIcon class="h-8" />
								</div>
							</div>
						</div>
					</div>
					: <div class="flex gap-2 items-center justify-center">
						<a class="bg-blue-whale-500 m-3 px-2 py-1 rounded shadow-lg text-white text-xl flex gap-2 items-center" href="javascript:void(0);" onClick={e => { Ticket.continue(); Ticket.reserve() }}>
							<I.ShareIcon class="h-4" />
							<span><Trans>Share</Trans></span>
						</a>
					</div>}
			</StatusMessageText>
			<StatusMessageButtons>
				<StatusMessageAccept onClick={() => { Ticket.continue() }}><Trans>Repeat</Trans></StatusMessageAccept>
				<StatusMessageCancel onClick={() => { Ticket.reset() }}><Trans>Clear</Trans></StatusMessageCancel>
				<StatusMessageAccept onClick={() => { printCurrentTicket() }}><Trans>Print</Trans></StatusMessageAccept>
			</StatusMessageButtons>
		</StatusMessage>;
	}
	return null;
}

const shareReservedBet = async (betId) => {
	if (navigator.share) {
		try {
			await navigator.share({
				title: `Booked bet ${betId}`,
				text: `Use the Booking id ${betId} to place my bet, or use this link: ${window.location.origin}/recall/${betId}`,
				url: `${window.location.origin}/recall/${betId}`
			});
		} catch (error) {
			console.error('Error sharing', error);
		}
	}
};



const ERROR_MESSAGES = {
	"login:please-login": 'Please log in. If you have already logged in, please contact support.',
	"invalidData:invalid-json": 'Invalid data format (JSON)',
	"invalidData:service-disabled": 'Not authorized to use this service',
	"invalidData:invalid-ticket": 'Invalid ticket!',
	"invalidData:invalid-data": 'Invalid ticket!',
	"invalidData:invalid-teams-coupling": 'Some events cannot be mixed',
	"invalidData:deleted-odd": 'Some odds are no longer available',
	"invalidData:event-started": 'One or more events have already started',
	"invalidData:invalid-bindings": 'Some odds cannot be played together',
	"invalidData:invalid-specials-bindings": 'Some odds cannot be played together',
	"invalidData:generic-error": 'Contact support for assistance',
	"invalidData:odds-changed": 'Some odds have changed',
	"invalidData:odds-closed": 'Some odds are no longer available',
	"invalidData:non-system-duplicate-event": 'An event is listed more than once',
	"invalidData:invalid-system-imports": 'System imports are not valid',
	"invalidData:system-type-selected-no-import": 'Cannot stake 0 in a system column',
	"invalidData:system-total-empty": 'Cannot stake 0.00',
	"invalidData:system-total-too-low": 'Minimum stake not met',
	"invalidData:system-total-too-high": 'Maximum amount exceeded',
	"invalidData:system-single-too-high": 'Maximum amount exceeded',
	"invalidData:betlimit": 'Maximum amount exceeded',
	"invalidData:win-too-high": 'Maximum win exceeded',
	"invalidData:less_than_plaform": 'Stake amount is less than platform minimum',
	"invalidData:more_than_plaform": 'Win amount is more than platform maximum',
	"invalidData:null_import": 'Bet amount is less than platform minimum.',
	"confirmBet:odds-changed": 'Some odds have changed.',
	"confirmBet:odd-not-compatible": 'Some odds cannot be on the same ticket. Please try again',
	"message:legature": 'Multiplicity not respected',
	"message:account-blocked": 'We apologize, betting is not possible because the account has been blocked.',
	"message:internal-error": 'An internal error occurred. Please contact support',
	"message:betlimit": 'Maximum amount exceeded',
	"message:winlimit": 'Maximum win exceeded',
	"message:maxload": 'Rejected by operator',
	"message:match_maxload": 'Rejected by operator',
	"message:repeatlimit": 'Maximum number of bets exceeded',
	"message:repeatwinlimit": 'Maximum number of repeated bets exceeded',
	"message:bet-import-too-low": 'Stake amount too low',
	"message:bet-import-too-high": 'Maximum amount exceeded',
	"message:col-too-low": 'Stake amount for system type too low',
	"message:win-too-high": 'Maximum win exceeded',
	"message:Not enough funds": 'Please top-up your account to place a bet',
	"message:below_bonus_min": 'Minimum stake for bonus bets is not met',
	"invalidData:min-bet-error": 'Your bet amount is less than the platform minimum',
	"invalidData:max-bet-error": 'Maximum amount exceeded',
	"adminPrompt:affiliate-manual-recharge": 'This client has no funds',
	"status:ticket-rejected": 'Ticket Rejected',
	"status:ticket-accepted": 'Ticket Accepted',
	"betDone:done": 'Ticket Accepted',
	"undefined:done": 'Live Bet Placed'
};

const ERROR_TITLES = {
	default: "Warning",
	"confirmBet:odds-changed": "Warning!"
}
const ERROR_INFO = {
	"invalidData:invalid-teams-coupling": {
		additionalData: (error) => <ul>{error.data.teams.map(e => <li>e</li>)}</ul>,
	},
	"invalidData:deleted-odd": {
		additionalData: (error) => <span>{error.data.odd.match} - {error.data.odd.segno}</span>,
	},
	"invalidData:event-started": {
		additionalData: (error) => <span>{!!error.data.eventFaults ? error.data.eventFaults.join(' - ') : ''}</span>,
	},
	"invalidData:win-too-high": {
		additionalData: (error) => <span>Max Win: {error.data.max}</span>,
	}
}

function printCurrentTicket() {
	if (Ticket.status.data.reserved) {
		Page.printReserved(Ticket.status.data.pendingId);
	} else {
		Page.printTicket({ code: Ticket.status.data.idbets || Ticket.status.data.code, id: Ticket.status.data.pendingId });
	}
}

const StatusMessage = P.StatusMessage;
const StatusMessageText = P.StatusMessageText;
const StatusMessageButtons = P.StatusMessageButtons;
const StatusMessageCancel = P.StatusMessageCancel;
const StatusMessageAccept = P.StatusMessageAccept;
